export default {
  user: {
    name: null,
  },
}
